import { createContext } from 'react'

const StreamContext = createContext({})

export default StreamContext
